// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.103.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.joinus {
  width: 1200px;
  margin: 0px auto;
  border: 1px solid #ddd;
  padding-top: 30px;
  border-radius: 10px;
  margin-bottom: 40px;
}
.joinus-con {
  width: 1000px;
}
.joinus .buttomBo {
  padding-left: 40%;
}
.joinus .buttomBo .ant-btn {
  margin: 0px 5px;
}
:global(.ant-message) {
  position: fixed !important;
  top: 100px !important;
  z-index: 9999 !important;
  transform: translateX(-50%);
  left: 50% !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/JoinUs/index.less"],"names":[],"mappings":"AAAA;EAAQ,aAAA;EAAc,gBAAA;EAAiB,sBAAA;EAAuB,iBAAA;EAAkB,mBAAA;EAAoB,mBAAA;AAOpG;AANG;EAAM,aAAA;AAST;AAVA;EAEa,iBAAA;AAWb;AAbA;EAGe,eAAA;AAaf;AARA;EACE,0BAAA;EACA,qBAAA;EACA,wBAAA;EACA,2BAAA;EACA,oBAAA;AAUF","sourcesContent":[".joinus{width:1200px; margin:0px auto; border:1px solid #ddd; padding-top:30px; border-radius:10px; margin-bottom: 40px;\n   &-con{width:1000px;}\n   .buttomBo{padding-left:40%;\n      .ant-btn{margin:0px 5px;}\n   }\n}\n\n// 让 message 组件固定在视口顶部\n:global(.ant-message) {\n  position: fixed !important;\n  top: 100px !important;\n  z-index: 9999 !important;\n  transform: translateX(-50%);\n  left: 50% !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
